/**
 * Maps a @vista-digital/ocapi-types CensorRating entity to a schema.org/Rating type.
 */
export const mapCensorRatingToRatingSchema = (censorRating, i18n, censorRatingNote) => {
    return {
        '@type': 'Rating',
        ratingValue: i18n.translatable(censorRating.classification),
        ratingExplanation: i18n.translatable(censorRatingNote || censorRating.classificationDescription)
    };
};
